module.exports = __webpack_public_path__ + "img/success.146feb0d.png";